
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles'

const HoopSwitch = withStyles(theme => ({
  root: {
    // width: '65%',
  //   height: '2.5em',
  //   padding: 0,
  //   display: 'flex',
  },
  switchBase: {
    color: '#aaaaaa',//'#fc6723',
    '&$checked': {
      color: '#fc6723',
    },
    '&$checked + $track': {
      backgroundColor: '#fc6723',
    },
  },
  checked: {},
  // thumb: {
  //   width: '40px',
  //   height: '30px',
  //   borderRadius:' 30%',
  // },
  input: {
    left: 0,
  },
  track: {},
}))(Switch);

export default HoopSwitch